// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2cWdp","select":"Header_select__3I6Fu","clinic":"Header_clinic__iwe6S"};